//client/src/pages/admin/AdminInternalOrdersList.js
import { useEffect, useState } from "react";
import api from "../../api/axiosInstance";

export default function AdminInternalOrdersList() {
  const [orders, setOrders] = useState([]);
  const [status, setStatus] = useState("all");

  const load = async () => {
    const res = await api.get("/admin/internal-orders", {
      params: status === "all" ? {} : { status },
    });
    setOrders(res.data || []);
  };

  useEffect(() => {
    load();
  }, [status]);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Internal Orders Status</h1>

      <select
        className="input-glass max-w-xs"
        value={status}
        onChange={(e) => setStatus(e.target.value)}
      >
        <option value="all">All</option>
        <option value="pending">Pending</option>
        <option value="processing">Processing</option>
        <option value="completed">Completed</option>
        <option value="cancelled">Cancelled</option>
      </select>

      <div className="card-glass overflow-x-auto">
        <table className="table-glass">
          <thead>
            <tr>
              <th>ID</th>
              <th>Service</th>
              <th>Qty</th>
              <th>Status</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {orders.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center py-6 text-gray-400">
                  No internal orders
                </td>
              </tr>
            ) : (
              orders.map((o) => (
                <tr key={o._id}>
                  <td>#{o._id.slice(-6)}</td>
                  <td>{o.service?.name}</td>
                  <td>{o.quantity}</td>
                  <td>
                    <span className={`chip chip-${o.status}`}>
                      {o.status}
                    </span>
                  </td>
                  <td>₹{o.amount}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
